var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowUpcomponent = function SvgArrowUpcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.081.239 4.677 4.608a.802.802 0 0 1 0 1.148l-.778.766a.83.83 0 0 1-1.165 0L5.5 3.495 2.185 6.76a.83.83 0 0 1-1.165 0l-.778-.766a.801.801 0 0 1 0-1.148L4.92.239a.826.826 0 0 1 1.162 0Z",
    fill: "current"
  })));
};
export default SvgArrowUpcomponent;